export default {
  title: {
    name: 'Midea H5'
  },
  mxTitle: 'Midea Connect',
  mxHarmonyTitle: 'HarmonyOS Midea Connect',
  mxLongContent: 'MideaConnect grows with you',
  locale: 'English',
  problem: 'FAQ',
  help: 'Advice Feedback',
  guide: 'Operation Guide',
  welcome: "welcome",
  downloadNow: 'Download',
  netError: 'Network anomaly, please try again later',
  codeLargeTip: '（You can click to enlarge and view the download QR code）',
  ok: 'OK',
  clickRightTopIOS: 'Click here and open in safari',
  clickRightTopAndroid: 'Click on the menu in the top right corner, and open in the browser',
  toProblem: '_problem-en',
  mideaConnect: "Since the MideaConnect is a enterprise application, it requires you to trust the application certificate after the first installation. Please go to your phone's Settings > General > VPN & Device Management > Midea Group Co., Ltd and click 'Trust'.",
  phoneSuccessTips: "After clicking 'Install', you can return to the desktop to view the installation status",
  mx: {
    introduce: 'Midea Connect is a communication & cooperation application for the Midea employees. It contains chat communication, video conferencing, document sharing, mini-program and other services, facilitating efficient communication and collaboration between employees.',
    downTips: 'Download MideaConnect client',
    ios: 'iOS',
    android: 'Android & HarmonyOS\n(Does not include HarmonyOS 5.0)',
    harmony: 'HarmonyNext\n(Harmony Next)',
    mac: 'macOS',
    window: 'Windows',
    downloadClick: 'Click to download',
    downloadScan: 'Scan to download',
    scanCodeDown: 'Scan QR code to download',
    harmonyScan: 'Scan the QR code using MideaConnect to join the group and download, or use MideaConnect - search and enter the group number below to join the group:',
    copySuccess: 'Copy successful',
    copyErrorTitle: 'Copy failed',
    copyError: '1.Check the browser\'s permission settings to ensure that it has the authority to write to the clipboard;2.The browser may not support copying, it is recommended to try changing the browser.',
    mobile_harmonyScan: 'Use MideaConnect scanning feature to join the group and download',
    mobile_joinGroup_long: 'To join the group, use the MideaConnect and enter the group number provided below in the search bar:',
    mobile_getHarmony: 'Get the native HarmonyNext version',
    mobile_getHarmonyBeta: 'Get the HarmonyNext beta version',
    hormony_group: 'HarmonyOS Midea Connect chat group',
    downloadLink: 'Download link',
    downloadWithBrowser: 'Scan with your browser to download immediately.',
  },
  vpn: {
    title: 'Midea VPN',
    introduce: 'VPN is a network tool used internally by Midea Group, which can assist employees in remote work scenarios such as working from home, business trips, etc., improving work efficiency.',
    tips: 'Long press to save to the album or scan the QR code to download',
    downTips: 'Download VPN',
    configureSeq: 'Installation Guide',
    configureDownload: 'Configuration File',
    pcCoreAliens: 'switch to China overseas version',
    pcCoreZH: 'switch to China domestic version',
    iphoneCoreAliens: 'Download overseas version',
    iphoneCoreZH: 'Download China domestic version',
    downloadAliens: 'Scan to download',
    downloadZH: 'Scan to download',
  },
  MacDownload: {
    title: 'Download the version of Midea Connect that is more suitable for your Mac',
    text1: 'Midea Connect has been optimized for both Mac computers using Intel chips and those using Apple chips. Using the correct version can help reduce resource consumption and improve software performance.',
    text2: "How to determine your Mac computer's chip type?",
    "text2-intel": "Detected that your computer's chip is Intel. It is recommended that you use the Intel chip version of the Midea Connect.",
    "text2-apple": "Detected that your computer's chip is Apple. It is recommended that you use the Apple chip version of the Midea Connect.",
    text4: '*If you cannot confirm the chip version, you can directly download the Intel version.',
    macIntel: 'Download the Intel chip version',
    macM1: 'Download the Apple chip version',
    aboutLeft: '1. Click the Apple menu in the upper left corner and select ',
    about: 'About This Mac',
    aboutRight: '',
    gaishuLeft: '2. In the',
    gaishu: ' Processor',
    chuliqiLeft: ' column on the',
    chuliqi: ' Overview page',
    typeLeft: ', check whether the',
    type: ' chip type',
    intelLeft: ' is "',
    intel: 'Intel',
    appleLeft: '" or "',
    apple: 'Apple',
    appleRight: '"，and select the corresponding version to download.',
    img1: require('../assets/M1/img1_en.png'),
    img2: require('../assets/M1/img2_en.png'),
    img3: require('../assets/M1/img3_en.png'),
  }
}
